export default "__VITE_ASSET__B7HQXPc1__"